<ng-container *ngIf="(breadsCrumb$ | async)?.length > 1">
    <div
        class="flex gap-2 text-[20px] flex-wrap text-lg items-center mb-4"
        *ngIf="(breadsCrumb$ | async)?.length < 5; else elseBreads"
    >
        <div
            class="flex items-center gap-2"
            *ngFor="
                let item of breadsCrumb$ | async as breadsCrumb;
                let i = index
            "
        >
            <div
                [ngClass]="{
                    'cursor-pointer hover:underline hover:text-default text-gray-400':
                        i !== breadsCrumb.length - 1
                }"
                (click)="i !== breadsCrumb.length - 1 ? gotoTagLink(item) : ''"
                [matTooltip]="getTooltip(item)"
                matTooltipPosition="above"
            >
                {{ item?.name | truncate: 30 }}
            </div>
            <mat-icon *ngIf="i !== breadsCrumb.length - 1" class="icon-size-4">
                arrow_forward_ios
            </mat-icon>
        </div>
    </div>
</ng-container>
<ng-template #elseBreads>
    <div
        class="flex gap-2 text-[20px] flex-wrap text-lg items-center mb-4"
        *ngIf="breadsCrumb$ | async as breadsCrumb"
    >
        <ng-container *ngFor="let i of [0, 1]">
            <div
                class="text-gray-400 cursor-pointer hover:underline hover:text-default"
                (click)="gotoTagLink(breadsCrumb[i])"
                [matTooltip]="getTooltip(breadsCrumb[i])"
                matTooltipPosition="above"
            >
                {{ breadsCrumb[i]?.name | truncate: 30 }}
            </div>
            <mat-icon class="icon-size-4">arrow_forward_ios</mat-icon>
        </ng-container>

        <div
            class="text-gray-400 cursor-pointer hover:underline hover:text-default"
            [matMenuTriggerFor]="menu"
        >
            ...
        </div>

        <ng-container *ngFor="let i of [2, 1]">
            <mat-icon class="icon-size-4">arrow_forward_ios</mat-icon>
            <div
                [ngClass]="{
                    'cursor-pointer hover:underline hover:text-default text-gray-400':
                        i !== 1
                }"
                (click)="i !== 1 ? gotoTagLink(breadsCrumb.at(-i)) : ''"
                [matTooltip]="getTooltip(breadsCrumb.at(-i))"
                matTooltipPosition="above"
            >
                {{ breadsCrumb.at(-i)?.name | truncate: 30 }}
            </div>
        </ng-container>

        <mat-menu #menu>
            <div
                *ngFor="
                    let item of breadsCrumb$ | async as breadsCrumb;
                    let i = index
                "
            >
                <ng-container *ngIf="i > 1 && i < breadsCrumb.length - 2">
                    <div class="p-2 cursor-pointer">
                        <span
                            class="p-2 text-gray-400 hover:underline hover:text-default"
                            (click)="gotoTagLink(item, i)"
                            [matTooltip]="getTooltip(item)"
                            matTooltipPosition="above"
                        >
                            {{ item?.name | truncate: 20 }}
                        </span>
                    </div>
                </ng-container>
            </div>
        </mat-menu>
    </div>
</ng-template>
